class ScrollElements{

	constructor(){

		var self = this;
		this.scrollHandler = this.scrollHandler.bind(this);

		$(window).on('load', () => {

			setTimeout(() => {
				$(window).on('scroll', this.scrollHandler);
				this.scrollHandler();
			}, 100);

		});

	}

	scrollHandler() {

		$('[data-scroll], .Image, .Text > *, .Input').each((index, item) => {
			var $item = $(item);
			var offsetTop = $item.offset().top;

			if(
				($item.offset().top < ($(window).scrollTop() + $(window).height()) * 0.9) ||
				($(window).scrollTop() >= ($(document).height() - $(window).height()))
			){
				if(!$item.hasClass('viewed'))
					$item.addClass('viewed');
			}
		})

	}

}

export default new ScrollElements();



// WEBPACK FOOTER //
// ./js/components/scrollElements.js